<div *ngIf="field" [formGroup]="group">
    <mat-checkbox [formControlName]="field.name">{{field.label}}</mat-checkbox>
    <ng-container *ngIf="field.data">
        <div class="button-wrapper">
            <button (click)="onClick(field.data)" class="fs-6">leer más</button>  
        </div>  
    </ng-container>
    

</div>